export default {"src":"/_next/static/media/planet_8.3abc70d9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};